export const subscriptionKeys = {
  all: ['subscriptions'] as const,
  byUser: (userId: string) => [...subscriptionKeys.all, userId] as const,
};
